<template>
  <div class="container">
    <div class="img">
      <img src="/static/xyt.png" />
    </div>
    <div class="no">{{express.expressNo}}</div>
    <div class="item">快递公司：{{express.expressCompany?express.expressCompany.name:""}}</div>
    <div class="item">收件电话：{{express.receiverPhone}}</div>
    <div class="item">保管费用：{{(express.safekeepFee/100).toFixed(1)}} 元</div>
    <div class="item" v-if="express.safekeepNeedPay && !express.isPayed">
      取件编码：<font class="password">支</font><font class="password">付</font><font class="password">后</font><font class="password">显</font><font class="password">示</font>
    </div>
    <div class="btn" v-if="express.safekeepNeedPay && !express.isPayed" @click="goPay">去支付</div>
    <div v-else>
        <div class="code-title">取件码</div>
        <div class="code">{{express.storageNo+"-"+express.tag}}</div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      express: {}
    };
  },
  created() {
    let _id = this.$route.params.expressId;
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    let loading = weui.loading("数据加载ing...", {
      className: "custom-classname"
    });

    // 根据ID获取qrcode
    axios
      .get("/api/expressTosend/getById/" + _id)
      .then(res => {
        loading.hide();
        if (res.data.success) {
          this.express = res.data.data;
        }
      })
      .catch(err => {
        setTimeout(() => {
          loading.hide();
        }, 500);
      });
  },
  methods: {
    goPay() {
      let that = this;
      // 生成prepayId并调用支付
      axios
        .get("/api/expressTosend/paysafekeep/" + this.express._id)
        .then(res => {
          if (res.data.success) {
            let payConfig = res.data.data;
            payConfig.success = function(res) {
              // 改变当前记录状态
              that.express.isPayed = true;
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    }
  }
};
</script>

<style scoped>
.container {
  margin: 30px;
}
.img {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 20px;
}
img {
  width: 120px;
  height: 120px;
  margin: auto;
}
.no {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    background-color: #bbbbbb;
    color: #ffffff;
    padding: 8px;
}
.item {
  margin-bottom: 10px;
  font-size: 20px;
}
.password {
  background-color: #aaaaaa;
  color: #ffffff;
  font-size: 16px;
  padding: 4px 4px;
  margin-right: 3px;
}
.btn {
  background-color: tomato;
  display: flex;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-top: 40px;
  font-size: 20px;
}
.code-title {
   background-color: #bbbbbb;
   display: flex;
   color: #ffffff;
   align-items: center;
   justify-content: center;
   padding: 10px;
   margin-top: 20px;
   font-size: 20px;
}
.code {
    color: #555;
    font-size: 32px;
    font-weight: bold;
    padding: 20px;
    text-align: center;
    border: 1px solid #bbbbbb;
}
</style>


// WEBPACK FOOTER //
// src/components/ExpressTopay.vue